var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M6 12c0-.585.239-1.086.637-1.42l8.92-8.189c.637-.585 1.513-.501 2.07.167.478.669.478 1.588-.16 2.09l-7.804 7.185q-.12.125 0 .25l7.805 7.186c.637.585.717 1.504.16 2.173-.558.668-1.434.752-2.071.167l-.08-.084-8.84-8.105C6.24 13.086 6 12.501 6 12"
  })));
};
export default SvgChevronLeft;